<template>
  <div class="manhole-monitor">
    <v-card
      :width="monitorWidth"
      class="wrap-container overflow-y-auto d-flex align-content-start flex-wrap"
      height="100vh"
      tile
      flat
      color="#F5F5F5"
    >
      <v-card
        class="pt-2 px-2 d-flex"
        :width="monitorWidth"
        tile
        flat
        color="#F5F5F5"
      >
        <div class="caption font-weight-bold">マンホール・水路モニタ</div>
        <v-btn class="ml-auto mr-2" x-small icon @click="close()">
          <v-icon x-small>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card>
      <v-card
        v-for="station in stations"
        :key="station.id"
        class="pa-2"
        :width="cardWidth"
        tile
        flat
        color="#F5F5F5"
      >
        <div class="caption station-area">
          <v-card class="d-flex" height="26" flat tile>
            <div>{{ station.name }}</div>
            <v-btn class="ml-auto" x-small text @click="moveStation(station)">
              詳細を見る
            </v-btn>
          </v-card>
          <ManholeChart
            v-if="station.timeSeries.length > 0"
            :height="180"
            :observatory="station"
            :timeSeries="station.timeSeries"
            :currentLevel="station.currentLevel"
          />
          <v-card
            v-else
            class="d-flex align-center justify-center"
            :height="180"
            outlined
            color="#F5F5F5"
          >
            欠測しています
          </v-card>
        </div>
      </v-card>
    </v-card>
  </div>
</template>
<script>
import * as axiosHelper from "../utils/axiosHelper";
import L from "leaflet";
// import moment from "moment";
import { OBSERVATORY } from "../enums/Type";
import * as common from "../utils/common";
import ManholeChart from "./base-map/details/ManholeChart";
export default {
  name: "ManholeMonitor",
  components: {
    ManholeChart
  },
  data() {
    return {
      cardWidth: 300,
      windowWidth: window.innerWidth,
      stations: []
    };
  },

  computed: {
    manholes() {
      const observatories = this.$store.getters.observatories;
      if (!observatories) return [];
      return observatories.filter(obs =>
        [OBSERVATORY.MANHOLE.code, OBSERVATORY.MANHOLE_WATERWAY.code].includes(
          obs.type
        )
      );
    },
    rowPanelNum() {
      // const num = Math.floor((this.windowWidth - 500) / this.cardWidth);
      // if (num < 1) {
      //   return 1;
      // } else {
      //   return num;
      // }
      return 2;
    },
    monitorWidth() {
      return this.cardWidth * this.rowPanelNum + 5;
    },
    map() {
      return this.$store.getters.leafletMap;
    },
    baseDate() {
      return this.$store.getters.baseDate;
    }
  },

  watch: {
    baseDate(newval, oldval) {
      if (!newval.isSame(oldval)) {
        this.sync();
      }
    },
    manholes() {
      this.sync();
    }
  },

  created() {
    window.addEventListener("resize", this.resizeWindow);
    this.sync();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeWindow);
  },

  mounted() {
    //
  },

  methods: {
    resizeWindow() {
      this.windowWidth = window.innerWidth;
    },
    close() {
      this.$store.commit("SET_IS_MANHOLE_MONITOR", false);
    },
    moveStation(station) {
      this.map.panTo(new L.LatLng(station.lat, station.lng));
      this.$store.commit("SET_SELECTED_OBSERVATORY", station);
      this.$store.commit("SET_MAP_DETAIL", {
        isShowing: true,
        title: station.name,
        contents:
          station.type === OBSERVATORY.MANHOLE.code
            ? "manhole-detail"
            : "waterway-detail"
      });
    },
    async sync() {
      if (this.manholes.length === 0) return;
      const targets = JSON.parse(JSON.stringify(this.manholes));
      const processes = targets.map(target => {
        return (async () => {
          const params = {
            date: this.baseDate.format("YYYY/MM/DD HH:mm"),
            id: target.id,
            type: target.type
          };
          const response = await axiosHelper.get("/observatories/data", params);
          if (response !== null && response.timeSeries) {
            target.timeSeries = response.timeSeries;
            common.convertManholeTimeSeries(target);
          } else {
            target.timeSeries = [];
          }

          if (target.timeSeries) {
            const levels = target.timeSeries
              .filter(l => l !== undefined && l.type === "real")
              .map(r => r.level);
            if (levels.length === 0) {
              target.currentLevel = null;
            } else {
              target.currentLevel = Number(
                levels[levels.length - 1].toFixed(2)
              );
            }
          } else {
            target.currentLevel = null;
          }
        })();
      });
      await Promise.all(processes);
      this.stations = targets;
    }
  }
};
</script>

<style lang="scss" scoped>
.station-area {
  background-color: white;
  padding: 8px 14px;
  cursor: pointer;
  border: 1px solid rgb(228, 228, 228);
}
</style>
